import React from 'react';
import ErrorMessage from '../../../components/ErrorMessage';
import RemoveContentSection from '../../../components/RemoveContentSection';
import { VolumeMaterialSection } from '../models/volume';
import VolumeHeadersList from './VolumeHeadersList';

type VolumeHeadersSectionProps = {
  headers: VolumeMaterialSection[] | [];
  volumeName: string;
  onRemove: () => void;
};

export const VolumeHeadersSection = ({ headers, volumeName, onRemove }: VolumeHeadersSectionProps) => {
  return (
    <>
      <VolumeHeadersList headers={headers} />
      <div className="grid-container grid-col-4 grid-sm-col-8 grid-col-gap-32">
        <div className="grid-col-span-4 grid-sm-col-span-2"></div>
        <div className="grid-col-span-4">
          <RemoveContentSection
            type="Volume"
            modalSubtext={volumeName}
            modalContent={<ErrorMessage>Any materials associated with this volume will be lost</ErrorMessage>}
            onRemove={onRemove}
          />
        </div>
      </div>
    </>
  );
};
